import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)



export default new Vuex.Store({
  state: {
    ishidden: true,
    mobile:false,
    
},

mutations: {
    toggleActive: (state) => {
      
        state.ishidden=!state.ishidden      
    },
},

actions: {
    toggleActive({ commit }) {
        commit('toggleActive');
    },
},

getters: {
  getData: state => {
        return state.ishidden;
    },

}
})